export const getFeaturedVehicleIds = (featured = {}) =>
	(featured?.featuredCampaigns || []).flatMap(
		(campaign) => campaign.vehicleIds || campaign.vehicles?.map(({ id }) => id) || [],
	);
